export default __webpack_public_path__ + "static/media/cardano-img.e20f809f.svg";